import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { BRAND_LOGO_ASPECT_RATIO, BRAND_LOGO_FOR_DARK_BG, BRAND_LOGO_FOR_LIGHT_BG, BRAND_LOGO_MARK, BRAND_LOGO_MARK_ASPECT_RATIO } from '@/lib/brand/brand-assets';
import { cn } from '@/lib/utils';
export type BrandLogoVariant = 'forDarkBg' | 'forLightBg';
const wordmarkByVariant = {
  forDarkBg: BRAND_LOGO_FOR_DARK_BG,
  forLightBg: BRAND_LOGO_FOR_LIGHT_BG
} as const;
type BrandLogoProps = {
  variant: BrandLogoVariant;
  href?: string;
  /** Rendered logo height in px; width follows aspect ratio. */
  height?: number;
  /** Use icon-only mark instead of full wordmark (e.g. collapsed sidebar). */
  compact?: boolean;
  className?: string;
  priority?: boolean;
};
export function BrandLogo(t0) {
  const $ = _c(18);
  const {
    variant,
    href,
    height: t1,
    compact: t2,
    className,
    priority: t3
  } = t0;
  const height = t1 === undefined ? 40 : t1;
  const compact = t2 === undefined ? false : t2;
  const priority = t3 === undefined ? false : t3;
  const src = compact ? BRAND_LOGO_MARK : wordmarkByVariant[variant];
  const aspectRatio = compact ? BRAND_LOGO_MARK_ASPECT_RATIO : BRAND_LOGO_ASPECT_RATIO;
  let t4;
  if ($[0] !== aspectRatio || $[1] !== height) {
    t4 = Math.round(height * aspectRatio);
    $[0] = aspectRatio;
    $[1] = height;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const width = t4;
  let t5;
  if ($[3] !== className) {
    t5 = cn("max-w-none object-contain object-left", className);
    $[3] = className;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== height || $[6] !== width) {
    t6 = {
      width,
      height
    };
    $[5] = height;
    $[6] = width;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== height || $[9] !== priority || $[10] !== src || $[11] !== t5 || $[12] !== t6 || $[13] !== width) {
    t7 = <Image src={src} alt="Cadrino ERV" width={width} height={height} priority={priority} className={t5} style={t6} />;
    $[8] = height;
    $[9] = priority;
    $[10] = src;
    $[11] = t5;
    $[12] = t6;
    $[13] = width;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const image = t7;
  if (!href) {
    return image;
  }
  let t8;
  if ($[15] !== href || $[16] !== image) {
    t8 = <Link href={href} className="inline-flex shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cadrino-primary/50 rounded-sm">{image}</Link>;
    $[15] = href;
    $[16] = image;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}